//#region Imports & External Dependencies
import { action, computed, makeObservable, observable } from "mobx";
import { FieldType, ViewModelBase } from "@shoothill/core";
import { APIClient, RelayCommand } from "Application";
import { StudentTargetModel, StudentTargetModelValidator } from "./StudentTargetModel";
import { StudentSubTargetViewModel } from "../StudentSubTarget/StudentSubTargetViewModel";
//#endregion

//#region Class Definition
export class StudentTargetViewModel extends ViewModelBase<StudentTargetModel> {
    //#region Properties & State
    public apiClient = new APIClient();
    //region child viewModels
    public _subTargetViewModels = observable<StudentSubTargetViewModel>([]);
    public _showError: boolean = false;
    //#endregion

    //#region Constructor/Initialization
    constructor(model = new StudentTargetModel()) {
        super(model, false, false);
        this.setValidator(new StudentTargetModelValidator());
        makeObservable(this, {
            _showError: observable,
            //actions
            setShowError: action,

            //computed
            subTargetViewModels: computed,
            showError: computed,
        });
    }
    //#endregion

    //#region Properties & Getters
    public get reference() {
        return this.model.reference;
    }

    public get description() {
        return this.model.description ?? "";
    }

    public get isCompletedByMentor(): boolean {
        return this.model.subTargets.every((x) => x.isCompletedByMentor);
    }

    public get subTargetViewModels() {
        return this._subTargetViewModels;
    }

    public get showError() {
        return this._showError;
    }

    public get errorMessage() {
        return "At least one subTarget has fields that need to be filled.";
    }
    //#endregion

    //#region Public Methods & Commands
    public setShowError(value: boolean) {
        this._showError = value;
    }

    public validateModel = () => {
        let isValid = false;
        const filteredSubTargets = this.subTargetViewModels.slice().filter((sst) => sst.model.isCompletedByMentor);

        filteredSubTargets.forEach((sst) => {
            isValid = sst.validateModel();
        });

        return isValid;
    };

    public onSubTargetCompletedByMentorCommandCallback = new RelayCommand(() => {
        this.validateModel();
    });
    //#endregion

    //#region Private Methods & Helpers
    private updateField = (fieldName: keyof FieldType<StudentTargetModel>, value: any) => {
        this.setValue(fieldName, value);
        this.isFieldValid(fieldName);
    };
    //#endregion
}
//#endregion
